module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-lace straps-Ki-La.5057016e.png";